import { differenceInCalendarDays, format, isValid, parseISO, startOfDay } from "date-fns";

export const normalizeQuery = (v: string): string => (v || "").trim().toLowerCase();

export const safeString = (v: any): string => (v === 0 ? "0" : v ? String(v) : "");

// ─────────────────────────────── USERS / SUBSCRIPTIONS (универсально под оба бэка)

export const pickPlanCode = (u: any): string =>
    safeString(
        u?._ui?.planCode ||
        u?.subscription?.plan?.code || // объект
        u?.subscription?.plan || // строка (как в /admin/users)
        u?.subscription?.code || // на всякий
        "",
    );

export const pickExpiresAt = (u: any): string | null =>
    (u?._ui?.expiresAt ??
        u?.subscription?.expiresAt ??
        u?.subscription?.expires_at ?? // snake_case (как в /admin/users)
        null) as string | null;

export const pickEmailKey = (u: any): string => {
    const v = safeString(u?.email).trim().toLowerCase();
    return v || "\uffff";
};

export const pickNameKey = (u: any): string => {
    const v = safeString(u?.name).trim().toLowerCase();
    return v || "\uffff";
};
